import OnboardingCoachmark from '../OnboardingCoachmark';
import { onboardingTargetIds } from '../../model/onboardingTargetIds';
import { SupportOperatorOnboardingCoachmarkProps } from './types';

const SupportOperatorOnboardingCoachmark = (props: SupportOperatorOnboardingCoachmarkProps) => {
  const {
    isOpen,
    onBack,
    onClose,
    onNext,
    stepNumber,
    totalSteps
  } = props;

  return (
    <OnboardingCoachmark
      description="Если понадобится помощь, нажмите на значок оператора."
      isOpen={isOpen}
      isTargetInteractive
      onBack={onBack}
      onClose={onClose}
      onPrimaryAction={onNext}
      placement="bottom"
      stepNumber={stepNumber}
      targetId={onboardingTargetIds.supportOperator}
      title="Помощь оператора"
      totalSteps={totalSteps}
    />
  );
};

export default SupportOperatorOnboardingCoachmark;